import { Trans } from '@lingui/react'

import { useSubmitIdentityVerificationIntroMutation } from '@twisto/api-graphql'
import {
  IntroStepContentBulletList,
  IntroStepContentHeadline,
} from '@twisto/flow-views/components'
import { FlowFormSubmitButton } from '@twisto/flow-views/components/flow-form-submit-info-view/flow-form-submit-button'
import { LawIcon, LockIcon, SecurityIcon } from '@twisto/icons'

import { useFlow } from '../../flow/flow.context'

export const IdentityVerificationIntroStep = () => {
  const { sessionId } = useFlow<'IdentityVerificationIntroStep'>()
  const [submitVerificationIntro] = useSubmitIdentityVerificationIntroMutation({
    variables: {
      auth: { sessionId },
    },
  })

  return (
    <>
      <IntroStepContentHeadline
        subtitle={<Trans id="flow.identityVerificationIntro.subtitle" />}
        title={<Trans id="flow.identityVerificationIntro.title" />}
      />
      <IntroStepContentBulletList
        items={[
          {
            icon: <LockIcon color="primary" height="100%" width="100%" />,
            text: <Trans id="flow.identityVerificationIntro.why.one" />,
          },
          {
            icon: <SecurityIcon color="primary" height="100%" width="100%" />,
            text: <Trans id="flow.identityVerificationIntro.why.two" />,
          },
          {
            icon: <LawIcon color="primary" height="100%" width="100%" />,
            text: <Trans id="flow.identityVerificationIntro.why.three" />,
          },
        ]}
      />

      <FlowFormSubmitButton onSubmit={submitVerificationIntro} />
    </>
  )
}
